import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';

export default function TipsSlider({ tips }) {
  return (
    <div className="MobileTellYourTailTipsSlider">
      <h3 className="mb6 primary">
        10 really important things you should know when getting a dog
      </h3>
      <ul>
        {tips.map(({ title, content, image }, idx) => (
          <li className="mb10" key={idx}>
            <div className="mb3">
              <SmartImage
                Tag="div"
                alt={`tip ${idx + 1}`}
                className="cover"
                src={image}
                width="100%"
                height="280px"
              />
            </div>
            <p className="mb1 f4 fw-medium primary">
              {idx + 1}. {title}
            </p>
            {/* eslint-disable-next-line react/no-danger */}
            <p dangerouslySetInnerHTML={{ __html: content }} />
          </li>
        ))}
      </ul>
    </div>
  );
}

TipsSlider.propTypes = {
  tips: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
